import SubtradeChannel from '../entities/SubtradeChannel'
import PaymentTerm from '../entities/PaymentTerm'
import KeyAccount from '../entities/KeyAccount'
export class PrimaryGroupOverride {
    ID: number;
    PrimaryGroup: string;
    KeyAccount: KeyAccount;
    SalesOrg: string;
    Inactive: boolean;
    SubtradeChannelID?: number;
    SubtradeChannel?: SubtradeChannel;
    PaymentTermID?: number;
    PaymentTerm?: PaymentTerm;
    DSDBarcodeFlag: string;
    StoreStampFlag: string;
    ACNNumber: string;
    EDIInboundProfileID: string;
    DUNSNumber: string;
    EDIVendorNumber: string;
    EDIOutboundProfileID: string;
    DEXCommID: string;
    DEXVersion: string;
    DEXEmpty: string;
    PODSDNumberIndicator: string;
    Document: string;
    Payer: string;
    AuthorizedMaterialList: string;
    LocCode: string;
    MinimumOrderQuantityFeeCode: string;
    DrPepperAuthorizedMaterialList: string;
    ZNPartnerRequired: boolean;
    IEI_Eligibility: string;
    AccountingClerk: string;
    PaymentEligibility: string;
    PaymentOptions: string;
    MyCokePermissions: string;
}

export default PrimaryGroupOverride;